import { useState } from "react";

import { Button, Icon, Menu, MenuItem, Position } from "@blueprintjs/core";

import { Popover } from "@/components/helpers/ui/blueprint-overrides/Popover";
import { Box, Flex } from "@/components/layout/flexbox";
import { GeneralAccessProps } from "@/components/pieces/roleplays/sharing/scenario-share/types";
import { VisibilityScope } from "@/graphql";

const titleCss = {
  fontSize: "14px",
  fontWeight: 500,
  color: "black",
};

export function GeneralAccess({
  visibilityScope,
  onChange,
  canShareToWorkspace = false,
}: GeneralAccessProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // Constants for access information
  const AccessIcons = {
    [VisibilityScope.User]: <Icon icon="lock" size={14} />,
    [VisibilityScope.Workspace]: <Icon icon="office" size={14} />,
  };

  const AccessInfo = {
    [VisibilityScope.User]: "Only people above can access",
    [VisibilityScope.Workspace]: "Anyone in your workspace can access",
  };

  const AccessButtonText = {
    [VisibilityScope.User]: "Restricted",
    [VisibilityScope.Workspace]: "Workspace",
  };

  return (
    <Flex alignItems="center">
      <Box
        css={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "#F4F1FF",
        }}
      >
        {AccessIcons[visibilityScope]}
      </Box>
      <Box css={{ marginLeft: 4 }}>
        <Popover
          canEscapeKeyClose={true}
          position={Position.BOTTOM_LEFT}
          usePortal={true}
          onClose={() => {
            setIsOpen(false);
          }}
          isOpen={isOpen}
          minimal={true}
          content={
            <Menu>
              <MenuItem
                text={AccessButtonText[VisibilityScope.User]}
                onClick={() => {
                  onChange(VisibilityScope.User);
                  setIsOpen(false);
                }}
              />
              <MenuItem
                text={AccessButtonText[VisibilityScope.Workspace]}
                onClick={() => {
                  onChange(VisibilityScope.Workspace);
                  setIsOpen(false);
                }}
              />
            </Menu>
          }
        >
          <Button
            rightIcon={canShareToWorkspace ? "caret-down" : undefined}
            style={{
              ...titleCss,
              padding: "0px 8px",
              cursor: canShareToWorkspace ? "pointer" : "default",
            }}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            minimal
            text={AccessButtonText[visibilityScope]}
            disabled={!canShareToWorkspace}
          />
        </Popover>
        <Box
          fontSize={12}
          css={{
            paddingLeft: 8,
          }}
        >
          {AccessInfo[visibilityScope]}
        </Box>
      </Box>
    </Flex>
  );
}
